import { useCallback } from "react";
import { useMutation } from "react-relay";
import { graphql } from "relay-runtime";

import { useAnswerAgentQuestionMutation as MutationType } from "./__generated__/useAnswerAgentQuestionMutation.graphql";

const mutation = graphql`
  mutation useAnswerAgentQuestionMutation($input: AnswerAgentQuestionInput!) {
    answerAgentQuestion(input: $input) {
      success
    }
  }
`;

interface QuestionAnswerType {
  question_index: number;
  selected_options: number[];
  other_text?: string;
}

export function useAnswerAgentQuestionMutation() {
  const [commit, isInFlight] = useMutation<MutationType>(mutation);

  const answerQuestion = useCallback(
    (
      toolUseId: string,
      answers: QuestionAnswerType[],
      llmConversationId: string | undefined,
      llmInteractionId: string | undefined
    ): Promise<boolean> => {
      return new Promise((resolve, reject) => {
        commit({
          variables: {
            input: {
              toolUseId,
              answers,
              llmConversationId,
              llmInteractionId,
            },
          },
          onCompleted: (response) => {
            resolve(response.answerAgentQuestion.success);
          },
          onError: (error) => {
            console.error("Failed to submit answer:", error);
            reject(error);
          },
        });
      });
    },
    [commit]
  );

  return {
    answerQuestion,
    isInFlight,
  };
}
